import {
    ConnectionProvider,
    WalletProvider,
} from "@solana/wallet-adapter-react";
import {
    PhantomWalletAdapter,
    SolflareWalletAdapter,
    LedgerWalletAdapter,
    SlopeWalletAdapter,
    SolletWalletAdapter,
    TorusWalletAdapter,
} from "@solana/wallet-adapter-wallets";
import { clusterApiUrl } from "@solana/web3.js";
import { useCallback, useState } from "react";
import { useImmer } from "use-immer";

import { GlobalContext } from "./Contexts/GlobalContext";
import { AuthProvider } from "./Providers/AuthProvider";
import { Content } from "./Components/Content";

import config from "./config.json";

const provider = process.env.REACT_APP_SOLANA_NETWORK_PROVIDER;
let network =
    config["SolanaNetworkProvider"][provider]?.["network"] ?? "mainnet-beta";
let endpoint;
switch (provider) {
    case "quicknode":
        endpoint = process.env.REACT_APP_QUICKNODE_URL;
        break;
    default:
        endpoint = clusterApiUrl(network, true);
        break;
}

const wallets = [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
    new LedgerWalletAdapter(),
    new SlopeWalletAdapter(),
    new SolletWalletAdapter({ provider: endpoint, network }),
    new TorusWalletAdapter(),
];

function GlobalContextProvider({ children }) {
    const [connectionConfig, updateConnectionConfig] = useImmer({
        commitment: "confirmed",
    });
    const changeConnectionConfig = useCallback(
        (jwt) => {
            if (jwt === "") {
                updateConnectionConfig((draft) => {
                    draft.httpHeaders = {};
                });
            } else {
                updateConnectionConfig((draft) => {
                    draft.httpHeaders = {
                        Authorization: `Bearer ${jwt}`,
                    };
                });
            }
        },
        [updateConnectionConfig]
    );

    const [walletErr, setWalletErr] = useState(null);
    const onWalletError = useCallback((err) => {
        setWalletErr(err);
    }, []);
    return (
        <GlobalContext.Provider
            value={{ changeConnectionConfig, walletErr, setWalletErr }}
        >
            <ConnectionProvider endpoint={endpoint} config={connectionConfig}>
                <WalletProvider
                    wallets={wallets}
                    autoConnect
                    onError={onWalletError}
                >
                    <AuthProvider>{children}</AuthProvider>
                </WalletProvider>
            </ConnectionProvider>
        </GlobalContext.Provider>
    );
}

function App() {
    return (
        <GlobalContextProvider>
            <Content />
        </GlobalContextProvider>
    );
}

export default App;
